module.exports = __webpack_public_path__ + "img/student_icon.bfb56c46.png";